import React from 'react';
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

const Dialog = styled.div`
    max-width: 800px;
    width:100% !Important;
`;

const CommentDialog =({onClose, body }) =>{
    return(
        <Dialog>
        <div className="confirmation--toolbar" style={{width:"800px"}}>
        <div className="confirmation--title">COMMENTS</div>
        <div className="confirmation--close"><FontAwesomeIcon icon={faTimes} size="lg" onClick={onClose}/></div>
        </div>

            <div className="confirmation--body">
                {body}
            </div>

        </Dialog>
    )

};
export default CommentDialog;